export const toTemplateSelect = templates =>
  templates.map(template => ({
    label: template.title,
    value: template.id
  }))
